import { LogLevel, StsConfigLoader } from "angular-auth-oidc-client";
import { AppConfigService } from "../services/app-config.service";
import { from, map, Observable } from "rxjs";

export class HttpLoaderFactory implements StsConfigLoader {

    constructor(private readonly appConfigService: AppConfigService) {}

    loadConfigs(): Observable<any> {
        return from(this.appConfigService.loadConfig()).pipe(
            map(() => {
                const config = this.appConfigService.config;
                const isLocalhost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
                const ssoProxyBaseUrl = '/fedssoqa';
                // La autorización es navegación top-level: debe ir directo a SSO para no romper la sesión de PingFederate.
                const authorizationEndpoint = config.firstBaseUrl;
                const tokenEndpoint = isLocalhost
                    ? `${ssoProxyBaseUrl}/as/token.oauth2`
                    : config.secondBaseUrl;
                const redirectUrl = isLocalhost
                    ? config.redirectUri
                    : window.location.origin + "/callback";

                return [
                    {
                        authority: config.baseUrlSso,
                        authWellknownEndpointUrl: isLocalhost ? ssoProxyBaseUrl : config.baseUrlSso,
                        strictIssuerValidationOnWellKnownRetrievalOff: isLocalhost,
                        redirectUrl,
                        clientId: config.clientId,
                        responseType: 'code',
                        scope: 'profile openid groups',
                        postLogoutRedirectUri: redirectUrl,
                        logLevel: LogLevel.Debug,
                        authWellknownEndpoints: {
                            authorizationEndpoint,
                            tokenEndpoint
                        },
                    }
                ]
            })
        )
    }
}

export function httpLoaderFactoryFn(appConfigService: AppConfigService) {
    return new HttpLoaderFactory(appConfigService);
}